// @flow

import { UPDATE_RANGE_FILTER, REMOVE_RANGE_FILTER } from '../../constants';
import type { RangeFilters } from '../../types';
import { removePropertyFromObject } from '../../../../helpers';

export type RangeFilterState = RangeFilters;

const initialState: RangeFilterState = {};

export type RangeFilter = {
  type: typeof UPDATE_RANGE_FILTER,
  payload: {
    label: string,
    from: number,
    to: number,
  },
};

export type RemoveRangeFilter = {
  type: typeof REMOVE_RANGE_FILTER,
  payload: {
    label: string,
  },
};

const filter = (
  state: RangeFilterState = initialState,
  action: RangeFilter | RemoveRangeFilter,
): RangeFilterState => {
  switch (action.type) {
    case UPDATE_RANGE_FILTER: {
      const { label, from, to } = action.payload;
      return {
        ...state,
        [label]: {
          from,
          to,
        },
      };
    }
    case REMOVE_RANGE_FILTER:
      return removePropertyFromObject(state, action.payload.label);
    default:
      return state;
  }
};

export default filter;
